export default "https://cdn-static.gokick.com/assets/528ec2ebd6131ff545f204827e0544e2c800444b/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";